import React from "react";

const ItemModalView = ({
  showItemModal,
  showAddItemModal,
  handleItemClose,
  onOpenAddItem,
  searchTerm,
  onSearchTermChange,
  selectedGroup,
  onSelectedGroupChange,
  itemGroups,
  controlHeight,
  filteredItemDataList,
  selectedItems,
  selectedRowIndex,
  onSelectAll,
  onToggleItem,
  onConfirm,
  getImageSrc,
  keyboardInstructions,
}) => (
  <>
    <div
      className={`modal ${showItemModal ? "show" : ""}`}
      style={{
        display: showItemModal ? "block" : "none",
        ...(showAddItemModal
          ? { filter: "blur(3px)", pointerEvents: "none", opacity: 0.6 }
          : {}),
      }}
      tabIndex="-1"
      role="dialog"
    >
      <div
        className="modal-dialog modal-lg"
        role="document"
        style={{
          maxWidth: 980,
          maxHeight: "calc(100vh - 160px)",
          margin: "1.75rem auto",
        }}
      >
        <div className="modal-content" style={{ overflow: "hidden" }}>
          <div className="modal-header d-flex align-items-center justify-content-between">
            <div
              className="d-flex align-items-center"
              style={{ width: "100%", justifyContent: "space-between" }}
            >
              <h5 className="modal-title mb-0">รายชื่อสินค้า</h5>

              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <button
                  type="button"
                  className="btn btn-success btn-lg"
                  onClick={onOpenAddItem}
                  title="เพิ่มสินค้า"
                  style={{ padding: "8px 18px", fontWeight: 600, minWidth: 120 }}
                >
                  + เพิ่มสินค้า
                </button>

                <button
                  type="button"
                  className="close"
                  onClick={handleItemClose}
                  aria-label="Close"
                  style={{
                    fontSize: "1.4rem",
                    lineHeight: 1,
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
          <div className="modal-body" style={{ paddingBottom: 0 }}>
            <div className="row g-3 align-items-end mb-3">
              <div className="col-md-6">
                <label className="form-label">ค้นหาสินค้า</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ค้นหา รหัสสินค้า หรือ ชื่อสินค้า"
                  value={searchTerm || ""}
                  onChange={(e) => onSearchTermChange(e.target.value)}
                  style={{ height: controlHeight }}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">หมวดหมู่สินค้า</label>
                <select
                  className="form-select form-control"
                  value={selectedGroup}
                  onChange={(e) => onSelectedGroupChange(e.target.value)}
                  disabled={itemGroups.length === 0}
                  style={{ height: controlHeight }}
                >
                  <option value="">ทั้งหมด</option>
                  {itemGroups.map((group) => (
                    <option key={group.Group_Id} value={String(group.Group_Id)}>
                      {group.Group_Name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div
              className="table-responsive"
              style={{ maxHeight: "calc(100vh - 320px)", overflowY: "auto" }}
            >
              <table className="table table-striped table-hover">
                <thead className="thead-dark">
                  <tr>
                    <th className="text-center" style={{ width: "3%" }}>
                      <input
                        type="checkbox"
                        onChange={(e) => onSelectAll(e.target.checked)}
                        checked={
                          filteredItemDataList.length > 0 &&
                          selectedItems.length === filteredItemDataList.length
                        }
                        style={{ width: 18, height: 18 }}
                      />
                    </th>
                    <th className="text-center" style={{ width: "20%" }}>
                      รูปสินค้า
                    </th>
                    <th className="text-center" style={{ width: "20%" }}>
                      รหัสสินค้า
                    </th>
                    <th className="text-center" style={{ width: "40%" }}>
                      ชื่อสินค้า
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItemDataList.length > 0 ? (
                    filteredItemDataList.map((item, index) => {
                      const imageSrc = getImageSrc(item.Item_Img);
                      return (
                        <tr
                          key={item.Item_Id || index + 1}
                          onClick={() => onToggleItem(item)}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              index === selectedRowIndex
                                ? "rgba(105, 188, 216, 0.8)"
                                : selectedItems.some(
                                    (selectedItem) =>
                                      selectedItem.Item_Id === item.Item_Id
                                  )
                                ? "rgba(105, 188, 216, 0.3)"
                                : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                        >
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={selectedItems.some(
                                (selected) => selected.Item_Id === item.Item_Id
                              )}
                              onChange={() => onToggleItem(item)}
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                cursor: "pointer",
                                width: 18,
                                height: 18,
                                transition: "background-color 0.3s ease",
                              }}
                            />
                          </td>
                          <td className="text-center align-middle">
                            {imageSrc ? (
                              <div className="d-flex justify-content-center">
                                <img
                                  src={imageSrc}
                                  alt={item.Item_Name || "รูปสินค้า"}
                                  style={{
                                    width: "48px",
                                    height: "48px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                    border: "1px solid rgba(0,0,0,0.08)",
                                  }}
                                />
                              </div>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td className="text-center align-middle">
                            {item.Item_Code}
                          </td>
                          <td className="text-left align-middle">
                            {item.Item_Name}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        ไม่พบข้อมูล
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer" style={{ paddingTop: 8 }}>
            <div
              className="text-left"
              style={{ fontSize: "12px", color: "#666", marginRight: "auto" }}
            >
              {keyboardInstructions}
            </div>
            <button
              className="btn btn-primary btn-lg"
              onClick={onConfirm}
              style={{ padding: "10px 18px", minWidth: 140, fontWeight: 600 }}
            >
              ยืนยัน (Enter)
            </button>
          </div>
        </div>
      </div>
    </div>
    {showItemModal && <div className="modal-backdrop fade show"></div>}
  </>
);

export default ItemModalView;
